import { useWapp } from '$logic/wapps/react-hook'
import { WithQueryTitleWrapper } from '$common/room-list-search/with-query-title-wrapper/with-query-title-wrapper'
import { WithQueryTitleBase } from '../with-query-title-base'

export function WithQueryWappRoomListItemTitle({
  wappId,
  query,
}: {
  wappId: string
  query: string
}) {
  const { entity: wapp } = useWapp(wappId)

  return (
    <WithQueryTitleWrapper>
      <WithQueryTitleBase
        query={query}
        title={wapp?.name || ''}
        variant="subtitle3"
      />
    </WithQueryTitleWrapper>
  )
}
